(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  window.addEventListener('load', (e) => {
    let details = document.querySelectorAll('details.footer-details');

    if (details.length > 0 && document.body.clientWidth > 749) {
      details.forEach((detail) => {
        detail.querySelector('summary').click();
        !detail.querySelector('summary').classList.contains('no-click') &&
          detail.querySelector('summary').classList.add('no-click');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = document.getElementById('shopify-section-header');

      // keep PTX parity: set --header-height once on init
      document.documentElement.style.setProperty(
        '--header-height',
        `${parseInt(this.header.offsetHeight)}px`
      );
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.root_theme = document.querySelector(':root');

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.root_theme.style.setProperty('--collection-nav-top', '0rem');
      // PTX parity: hidden + REMOVE sticky (was adding sticky before)
      this.header.classList.add('shopify-section-header-hidden');
      this.header.classList.remove('shopify-section-header-sticky');
      this.closeSearchModal();
      this.root_theme.style.setProperty('--sidebar-top', '2rem');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('header-sticky');
      this.root_theme.style.setProperty('--sidebar-top', '17rem');
      this.updateDynamicStyles();

      // keep var accurate if sticky height differs
      document.documentElement.style.setProperty(
        '--header-height',
        `${parseInt(this.header.offsetHeight)}px`
      );
    }

    reset() {
      this.root_theme.style.setProperty('--collection-nav-top', '0rem');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-sticky');
      this.root_theme.style.setProperty('--sidebar-top', '2rem');

      // keep var accurate when un-sticking
      document.documentElement.style.setProperty(
        '--header-height',
        `${parseInt(this.header.offsetHeight)}px`
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    updateDynamicStyles() {
      this.root_theme.style.setProperty('--collection-nav-top', window.innerWidth >= 750 ? '11rem' : '10rem');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal && this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('shopify:block:select', e => {
  	let parentDetails = e.target.closest('details');

  	if (parentDetails) {
  		parentDetails.open = true;
  	}

  	let megaBlock = e.target.classList.contains('mega-menu__promo-item')
  	if (megaBlock && megaBlock != e.target) {
  		document.querySelectorAll('.mega-menu').forEach(item => {
  			item.style.pointerEvents = 'none';
  		})
  	}
  });

  document.addEventListener('shopify:block:deselect', function(e) {
  	let parentDetails = e.target.closest('details');
  	let megaBlock = e.target.classList.contains('mega-menu__promo-item')
  	if (megaBlock && megaBlock != e.target) {
  		document.querySelectorAll('.mega-menu').forEach(item => {
  			if (parentDetails) {
  				parentDetails.open = false;
  			}
  			item.style.pointerEvents = 'all';
  		})
  	}
  });

  } catch(e) { console.error(e); }
})();
})();
